import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';

export class ParseObject extends Parse.Object {
  public static readonly OBJECT_ID_KEY = 'objectId';
  public static readonly UPDATE_AT_KEY = 'updatedAt';
  public static readonly CREATE_AT_KEY = 'createdAt';

  private _prevEntries: ParseObject[];

  constructor(className: string) {
    super(className);
    this._prevEntries = [];
  }

  public get updatedAt(): Date {
    return this.get(ParseObject.UPDATE_AT_KEY);
  }

  public set updatedAt(date: Date) {
    this.set(ParseObject.UPDATE_AT_KEY, date);
  }

  public get createdAt(): Date {
    return this.get(ParseObject.CREATE_AT_KEY);
  }

  public set createdAt(date: Date) {
    this.set(ParseObject.CREATE_AT_KEY, date);
  }

  public revert(): void {
    super['revert']();
  }

  public isNew(): boolean {
    return super['isNew']();
  }

  public dirty(attr?: string) {
    return super.dirty(attr);
  }

  public toFullJSON(seen?: any[]) {
    return super['_toFullJSON'](seen);
  }

  public get available() {
    return !!this.createdAt;
  }

  public static rx() {
    return {
      fetchAll: (items, option) => {
        return new Observable((o) => {
          Parse.Object.fetchAll(items, option).then(
            result => {
              o.next(result);
              o.complete();
            },
            error => {
              o.error(error);
            }
          )
        });
      }
    }
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/parse-object.ts